export default "__VITE_ASSET__Cfn$DLCt__"